import { createUseStyles } from "react-jss";
import { colors } from "../../../../styles/colors";
const useStyles = createUseStyles((_) => ({
  containerHistorique: {
    borderRadius: "15px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "13px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  historiqueContent: {
    maxHeight: "230px",
    minHeight: "230px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    overflow: "auto",
  },
  /*
   * Une entree d'historique.
   *
   * Separateur en bas plutot qu'une bordure complete : la liste defile dans un
   * panneau de hauteur fixe, et encadrer chaque ligne produit un empilement de
   * boites qui rend le defilement illisible. Le dernier element perd son trait
   * pour ne pas doubler le bord du conteneur.
   */
  entry: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    paddingBottom: "10px",
    borderBottom: `1px solid ${colors.borderLight}`,
    "&:last-child": {
      borderBottom: "none",
      paddingBottom: 0,
    },
  },
  entryHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  badge: {
    fontSize: "10px",
    lineHeight: 1,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    padding: "4px 8px",
    borderRadius: "10px",
    whiteSpace: "nowrap",
    color: colors.primary,
    border: `1px solid ${colors.primary}`,
  },
}));

export default useStyles;
